import { Box, Button, Stack } from '@mui/material'
import CommonLayout from 'layouts/DashboardLayout'
import React, { useEffect, useMemo } from 'react'
import { useSearchParams } from 'react-router-dom';
import GeneralTiming from './GeneralTiming/Index';
import CreateGeneralTiming from './GeneralTiming/CreateTiming';
import ShopTimingLogs from './GeneralTiming/ShopTimingLogs';
import EditTiming from './GeneralTiming/EditTiming';

const AsapIndex = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const fullRoleTab = useMemo(() => searchParams.get('roleTab'), [searchParams]);
    const editid = useMemo(() => searchParams.get('editid'), [searchParams]);

    useEffect(() => {
        if (editid) {
            setSearchParams({ roleTab: fullRoleTab ? fullRoleTab : 'generalTimings', editid: editid })
        }
        else {
            setSearchParams({ roleTab: fullRoleTab ? fullRoleTab : 'generalTimings' })

        }
    }, [fullRoleTab])

    return (
        <CommonLayout>
            {fullRoleTab === 'shopTimingLogs' ? <ShopTimingLogs /> :
                fullRoleTab === 'editgeneralTimings' ? <EditTiming /> :
                    fullRoleTab === 'creategeneralTimings' ? <CreateGeneralTiming /> :
                        fullRoleTab === 'generalTimings' ? <GeneralTiming /> : ""
            }
        </CommonLayout>
    )
}

export default AsapIndex
